import RequestPriorityType from './enums/RequestPriorityType';
import RequestPriorityTitle from './enums/RequestPriorityTitle';
import RequestPriorityDescription from './enums/RequestPriorityDescription';
import RequestPriorityColor from './enums/RequestPriorityColor';
import RequestStatusType from './enums/RequestStatusType';

/**
 * Приоритет обращения P1–P4: что показывать и кому разрешено менять.
 *
 * Решения вынесены из компонентов, чтобы проверяться тестами без монтирования: метка
 * в форме создания, строка в карточке, колонка списка и история.
 */

export const EMPTY_VALUE = '—';

/**
 * @param {number|null|undefined} priority
 * @returns {boolean}
 */
export function isKnownPriority(priority) {
    return RequestPriorityType.values().includes(priority);
}

/**
 * Короткая метка: «P1»…«P4». Неизвестное значение — прочерк, а не «Pundefined».
 *
 * @param {number|null|undefined} priority
 * @returns {string}
 */
export function priorityTitle(priority) {
    return isKnownPriority(priority) ? RequestPriorityTitle[priority] : EMPTY_VALUE;
}

/**
 * Полная подпись: «P1 — Критический / массовый».
 *
 * @param {number|null|undefined} priority
 * @returns {string}
 */
export function priorityLabel(priority) {
    if (!isKnownPriority(priority)) {
        return EMPTY_VALUE;
    }

    return `${RequestPriorityTitle[priority]} — ${RequestPriorityDescription[priority]}`;
}

/**
 * Цвета метки. Текст P1–P4 при этом всегда виден — цвет только дополняет его.
 *
 * @param {number|null|undefined} priority
 * @returns {{color: string, background: string}|null}
 */
export function priorityStyle(priority) {
    return isKnownPriority(priority) ? RequestPriorityColor[priority] : null;
}

/**
 * Варианты селектора приоритета — для карточки услуги и смены приоритета обращения.
 *
 * @returns {{value: number, title: string}[]}
 */
export function priorityOptions() {
    return RequestPriorityType.values().map((value) => ({ value, title: priorityLabel(value) }));
}

/**
 * Может ли текущий пользователь менять приоритет обращения.
 *
 * Исполнитель или администратор (у администратора роли исполнителя может не быть).
 * Закрытое обращение не меняется — бэкенд отвергнет так же, как смену исполнителя.
 *
 * @param {{isExecutor: boolean, isAdmin: boolean}} roles
 * @param {Object} request
 * @returns {boolean}
 */
export function canChangePriority(roles, request) {
    if (!roles || !(roles.isExecutor || roles.isAdmin)) {
        return false;
    }

    return !!request && request.status !== RequestStatusType.CLOSED;
}
